'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment } from 'react';
import { FaSortAmountDownAlt as SortAscIcon } from 'react-icons/fa';
import { FaSortAmountUp as SortDescIcon } from 'react-icons/fa';
import Button from '@material-ui/core/Button';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import Pagination from 'Components/Pagination';
import CheckedIcon from 'Icons/Checked';
import bemit from 'Functions/bemit';
import Loader from 'Pure/Loader';
const {
  app,
  qwest
} = window;
export default class Dashboard extends Component {
  state = {
    loading: true,
    data: [],
    data_count: 0,
    page: 0,
    rows_per_page: this.props['items-per-page'] || 10,
    order: this.props.order || 'desc',
    order_by: this.props['order-by'] || 'created_at',
    searched: '',
    status_messages: {},
    selected: {}
  };
  pending_req = {};
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchData({});
    if (props['request-update']) {
      app.push({
        event: props['request-update'],
        cb: component.requestUpdate
      });
    }
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.clearPendingRequests();
    if (props['request-update']) {
      app.delete({
        event: props['request-update'],
        cb: component.requestUpdate
      });
    }
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    const prev_filters = prev_props.filters || {};
    const changes = Object.keys(props.filters || {}).some(function (field) {
      if (!props.filters[field] && !prev_filters[field]) return false;
      return props.filters[field] !== prev_filters[field];
    });
    if (changes) component.fetchData({
      page: 0
    });
  }
  fetchData = ({
    page,
    order,
    order_by
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const current_page = typeof page === 'undefined' ? state.page : page;
    let update = {};
    [page, order, order_by].filter(prop => typeof prop !== 'undefined').forEach(prop => update[prop] = prop);
    component.setState({
      ...update,
      loading: true,
      selected: {}
    });
    qwest.post(props.url, {
      limit: state.rows_per_page,
      skip: state.rows_per_page * current_page,
      with_count: true,
      ...(props.filters || {}),
      order: order || state.order,
      order_by: order_by || state.order_by
    }).then(function (xhr, response) {
      if (order) component.setState({
        order: order
      });
      if (order_by) component.setState({
        order_by: order_by
      });
      if (typeof props.onSelection === 'function') {
        props.onSelection();
      }
      if (props['request-update']) {
        app.emit({
          event: props['request-update'] + 'Fetched',
          data: {
            data: response.data || [],
            count: response.count || 0
          }
        });
      }
      component.setState({
        loading: false,
        data_count: response.count || 0,
        data: response.data || []
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handlePageChange = (e, page) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      page: page
    });
    component.fetchData({
      page: page
    });
  };
  sort(e, field) {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    const order_by = field;
    let order = 'asc';
    if (state.order_by === order_by && state.order === 'asc') {
      order = 'desc';
    }
    component.fetchData({
      order: order,
      order_by: order_by
    });
  }
  toggleSelection = (e, data) => {
    const component = this,
      props = this.props,
      state = this.state;
    state.selected[data.id] = !state.selected[data.id];
    component.setState({
      selected: state.selected
    });
    props.onSelection(e, data);
  };
  clearPendingRequests = () => {
    const component = this,
      props = this.props,
      state = this.state;
    Object.keys(component.pending_req).forEach(function (id) {
      try {
        component.pending_req[id]?.cancel?.();
      } finally {
        component.pending_req[id] = undefined;
        delete component.pending_req[id];
      }
    });
  };
  requestUpdate = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchData({});
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const Row = props.component || undefined;
    let data = [];
    if (Row) {
      data = state.data.map(function (data) {
        const selection = props.onSelection ? /*#__PURE__*/React.createElement(Button, {
          className: "c-dashboard__cell selection",
          onClick: e => component.toggleSelection(e, data)
        }, /*#__PURE__*/React.createElement("span", {
          className: "u-readers-only"
        }, "Cocher"), state.selected[data.id] ? /*#__PURE__*/React.createElement(CheckedIcon, {
          className: "c-dashboard__selected"
        }) : undefined) : undefined;
        const output = /*#__PURE__*/React.createElement(Row, _extends({
          data: data,
          key: data.id,
          blank: props.blank,
          requestUpdate: component.requestUpdate,
          fields: props.fields
        }, props['row-props'] || {}), selection);
        return output;
      });
    } else if (typeof props.render === 'function') {
      data = state.data.map(data => props.render(data));
    } else {
      return null;
    }
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white']
    }) : undefined;
    const header = (props.header || []).map(function (field) {
      let classes = 'c-dashboard__cell';
      if (field.sortable !== false) classes += ' ' + 'sortable';
      classes += ' ' + props.model + '-' + field.name.split('.').join('_');
      let sort_class = 'c-dashboard__sort';
      if (field.align && field.align !== 'left') {
        classes += ' u-content-' + field.align;
      }
      const sort_indicator = state.order_by !== field.name ? undefined : state.order === 'asc' ? /*#__PURE__*/React.createElement(SortAscIcon, {
        className: "c-dashboard__sort-icon"
      }) : /*#__PURE__*/React.createElement(SortDescIcon, {
        className: "c-dashboard__sort-icon"
      });
      const sort_btn = field.sortable !== false ? /*#__PURE__*/React.createElement(Button, {
        className: sort_class,
        onClick: e => component.sort(e, field.name)
      }, field.label, sort_indicator) : field.label;
      let output = /*#__PURE__*/React.createElement("div", {
        key: field.name,
        className: classes
      }, sort_btn);
      return output;
    });
    const model_name = props.model.toLowerCase();
    let output = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "dashboard-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: bemit('c-dashboard', ['head', model_name])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__row"
    }, props.onSelection ? /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell selection"
    }) : undefined, header)), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-dashboard', [model_name])
    }, data)), props.pagination !== false ? /*#__PURE__*/React.createElement(Pagination, {
      current: state.page,
      total: state.data_count,
      empty_txt: props.empty_txt,
      "items-per-page": state.rows_per_page,
      onChange: component.handlePageChange
    }) : undefined, loader);
    return output;
  }
}
